import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import ViaHeader from './ViaHeader';
import ViaHeaderBynx from './ViaHeaderBynx';
import ViaContent from './ViaContent';
import ViaFooter from './ViaFooter';
import './ViaLayout.css';
import { selectSessionUser } from '../../state/ui/application/sessionUiReducer';
import { userIsAdminConsole } from '../../utility/security/security-util';
import {isPurCoInstall} from "../../configWeb";


export default function ViaLayout({
  showHeader, showFooter, className, style, children,
}) {
  const user = useSelector(selectSessionUser);

  const Header = useCallback(() => {
    if (!showHeader) return <></>;

    if (userIsAdminConsole(user)) return <ViaHeaderBynx />;
    return <ViaHeader showCredits={!isPurCoInstall()} />;
 }, [showHeader, user]);

  return (
    <div style={style} className={`via-layout ${className || ''}`}>
      <Header />
      <ViaContent>
        {children}
      </ViaContent>
      { showFooter && <ViaFooter /> }
    </div>
  );
}

// Validate prop type parameters.
ViaLayout.propTypes = {
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  children: PropTypes.element.isRequired,
};

ViaLayout.defaultProps = {
  showHeader: true,
  showFooter: true,
  className: undefined,
  style: {},
};
